import {pushDataLayer} from '@optimaxdev/analytics/mobile';

export type AnalyticsType = {
    eventCategory: string;
    eventLabel: string;
    eventAction?: string;
    isInteraction?: boolean;
};

// TODO: ANTeam It looks like all the events sent through this method are no longer relevant, since I have an outdated structure,
//  I need feedback from the analytics team to remove it completely or update it to the current structure
//  Do not use this method for new events!
/**
 * Push analytics to GTM
 * @param {AnalyticsType} - event data
 */
export function sendGTMAnalytics({
    eventCategory,
    eventLabel,
    eventAction = 'click',
    isInteraction = true,
}: AnalyticsType) {
    pushDataLayer({
        event: `GAEventGenericTrigger${isInteraction ? '' : 'Non'}Interaction`,
        eventCategory,
        eventAction,
        eventLabel,
    });
}
